import React, { Component } from 'react'
import { withTranslation } from 'react-i18next'
import axios from 'axios'

import Grunndata from './Grunndata.jsx'
import CollapseIcon from '../../../../images/expand copy 3.png'
import ExpandIcon from '../../../../images/collapse copy 3.png'
import PilIcon from '../../../../images//Icon_Pil-ny.png'

class GrunndataList extends Component {
    state = {
        grunndata: [],
        isGrunndataLoaded: false,
        isLoading: false,
        isOpened: false
    }

    getGrunndata = () => {
        this.setState({isLoading: true})
        axios.get(`${this.props.settings.baseUrl}api/grunnbok/grunndata/`, {
            params: {
                token: this.props.token,
                matrikkelenhetId: this.props.matrikkelenhetId,
                kommunenummer: this.props.kommunenummer,
                gardsnummer: this.props.gardsnummer,
                bruksnummer: this.props.bruksnummer,
                festenummer: this.props.festenummer,
                seksjonsnummer: this.props.seksjonsnummer
            }
        })
        .then(({data}) => {
            this.setState({
                grunndata: [...this.state.grunndata, ...data.grunndata],
                isGrunndataLoaded: true,
                isLoading: false})
        })
      }


    toggleGrunndata = () => {
        if (!this.state.isGrunndataLoaded) {
            this.getGrunndata()
        }

        this.setState({isOpened: !this.state.isOpened})
    }

    render() {
        const { t } = this.props
        return (
            <li>
                <div className="section-header subsection" onClick={this.toggleGrunndata}>
                    { !this.state.isLoading &&
                        <div className="icon-image"><img src={PilIcon} /></div>
                    }
                    {
                        this.state.isLoading &&
                        <span className="icon"><i className="fa fa-fw fa-spinner fa-spin"></i></span>
                    }                    
                    <span className="title">{t('grunndata')} {this.state.isGrunndataLoaded && `(${this.state.grunndata.length})`}</span>
                    <div className="icon-image right"><img className="collapse" src={this.state.isOpened ? CollapseIcon : ExpandIcon} /></div>
                </div>
                <div className={this.state.isOpened && this.state.grunndata.length > 0 ? "" : "collapsed"}>
                    <ul>
                        { this.state.grunndata.map((g, index) => { return (<Grunndata key={g.dokumentnummer+g.dokumentnavn} grunndata={g} isLast={index==this.state.grunndata.length-1} onEvent={this.props.onEvent} />)}) }
                    </ul>
                </div>
            </li>
        )
    }
}

export default withTranslation('common')(GrunndataList)